var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"section-sub-title",class:_vm.rootClasses},[_c('div',{directives:[{name:"scroll-reveal",rawName:"v-scroll-reveal.reset",value:({ distance: '240px', origin: 'left' }),expression:"{ distance: '240px', origin: 'left' }",modifiers:{"reset":true}}],staticClass:"separator"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }